export class newLabel {
  Id_Label = 0;
  Id_Language = 0;
  MenuText = '';
}
